<div class="hvac-map-container"  #hvacMap></div>
